import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "@/assets/styles/global.scss";
import { migrateLegacyBatches } from "@/utils/batchStorage";

migrateLegacyBatches();

// import * as Sentry from "@sentry/react";

if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

// Sentry.init({
//   dsn: "https://70b0788211635e92bd253123ec4afe1d@o4507600446750720.ingest.us.sentry.io/4507600448913408",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring./de
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

type ThemeMode = "light" | "retro" | "dark";

// 刷新时沿用用户在导航里选择的主题；未设置过则默认白灰
const savedTheme = localStorage.theme as ThemeMode | undefined;
const themeMode: ThemeMode =
  savedTheme === "dark" || savedTheme === "retro" || savedTheme === "light"
    ? savedTheme
    : "light";

document.documentElement.dataset.theme = themeMode;
document.documentElement.classList.remove("dark");

// 同步 localStorage：避免其它逻辑基于历史值误判
localStorage.theme = themeMode;

// 只有暗色需要 dark class
if (themeMode === "dark") {
  document.documentElement.classList.add("dark");
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);
